export default __webpack_public_path__ + "static/media/check.a9bb5f8f.svg";